export const PIN_MIN_LENGTH = 6;
export const PIN_MAX_LENGTH = 8;
